import cloudbase from '@cloudbase/js-sdk'
const app = cloudbase.init({
  env: 'fzct-9gqee4w01b3e62f7'
})
export default app
